document.addEventListener('DOMContentLoaded', function () {
  function enableAllFlatpickrDates() {
    const container = document.querySelector('.dayContainer');
    if (!container) return;

    const removeDisabledClasses = () => {
      container.querySelectorAll('.flatpickr-day.flatpickr-disabled').forEach(day => {
        day.classList.remove('flatpickr-disabled');
        day.removeAttribute('aria-disabled');
      });
    };

    // Run once initially
    removeDisabledClasses();

    // Then observe for DOM changes in the calendar
    const observer = new MutationObserver(removeDisabledClasses);
    observer.observe(container, { childList: true, subtree: true });
  }

  // Wait a bit to make sure flatpickr has rendered
  setTimeout(enableAllFlatpickrDates, 1000);
});
